export const brand = {
  red: "#b5281c",
  redSoft: "#d9554a",
  redDeep: "#8c1e14",
  navy: "#0b2b6c",
  navyDeep: "#06102e",
  navyLight: "#1e3a8a",
  gold: "#d97706",
  emerald: "#059669",
};

export const lightPalette = {
  mode: "light",
  brand,
  primary: {
    main: "#b5281c",
    light: "#d9554a",
    dark: "#8c1e14",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#0b2b6c",
    light: "#2563eb",
    dark: "#06102e",
    contrastText: "#ffffff",
  },
  background: {
    default: "#f8fafc",
    paper: "#ffffff",
    alt: "#f1f5f9",
    subtle: "rgba(181, 40, 28, 0.04)",
  },
  text: {
    primary: "#0f172a",
    secondary: "#475569",
    disabled: "#94a3b8",
  },
  success: {
    main: "#16a34a",
    light: "#dcfce7",
    dark: "#15803d",
    contrastText: "#ffffff",
  },
  warning: {
    main: "#f59e0b",
    light: "#fef3c7",
    dark: "#b45309",
    contrastText: "#ffffff",
  },
  error: {
    main: "#dc2626",
    light: "#fee2e2",
    dark: "#991b1b",
    contrastText: "#ffffff",
  },
  info: {
    main: "#0284c7",
    light: "#e0f2fe",
    dark: "#0369a1",
    contrastText: "#ffffff",
  },
  divider: "rgba(15, 23, 42, 0.08)",
  gradient: {
    primary: "linear-gradient(135deg, #b5281c 0%, #d9554a 100%)",
    navy: "linear-gradient(135deg, #0b2b6c 0%, #1e3a8a 100%)",
    hero: "linear-gradient(145deg, #06102e 0%, #0b2b6c 50%, #1e293b 100%)",
    gold: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
  },
};

export const darkPalette = {
  mode: "dark",
  brand,
  primary: {
    main: "#ef4444",
    light: "#f87171",
    dark: "#b5281c",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#60a5fa",
    light: "#93c5fd",
    dark: "#2563eb",
    contrastText: "#0f172a",
  },
  background: {
    default: "#090d16",
    paper: "#111827",
    alt: "#1f2937",
    subtle: "rgba(239, 68, 68, 0.08)",
  },
  text: {
    primary: "#f8fafc",
    secondary: "#94a3b8",
    disabled: "#64748b",
  },
  success: {
    main: "#22c55e",
    light: "#14532d",
    dark: "#16a34a",
  },
  warning: {
    main: "#fbbf24",
    light: "#78350f",
    dark: "#d97706",
  },
  error: {
    main: "#f87171",
    light: "#7f1d1d",
    dark: "#dc2626",
  },
  info: {
    main: "#38bdf8",
    light: "#0c4a6e",
    dark: "#0284c7",
  },
  divider: "rgba(255, 255, 255, 0.08)",
  gradient: {
    primary: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    navy: "linear-gradient(135deg, #1e3a8a 0%, #0b2b6c 100%)",
    hero: "linear-gradient(145deg, #030712 0%, #0b152b 50%, #111827 100%)",
    gold: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
  },
};
